import React from 'react';
import { useContactModalContext } from './contexts/ContactModalContext';

const WhatsAppFloat = () => {
  const { openModal } = useContactModalContext();

  const handleClick = (e) => {
    e.preventDefault();
    openModal("https://api.whatsapp.com/send/?phone=554799089366");
  };

  return (
    <button 
      onClick={handleClick}
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-cta hover:scale-110 transition-transform duration-300 active:scale-95 touch-manipulation"
      aria-label="Contato via WhatsApp"
    >
      <i className="fab fa-whatsapp text-white text-2xl md:text-3xl"></i>
    </button>
  );
};

export default WhatsAppFloat; 